/**
 * @module app.um
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { UtilizationManagementModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(UtilizationManagementModule.registrationKey, UtilizationManagementModule)

    // Load any other resources here
    //config.globalResources([
    //    // elements

    //    // value-converters
    //]);
}
